import { useMemo } from "react";
import tokenService from "services/token.service";
import { useAccount } from "wagmi";

export const useAuth = () => {
  const { address } = useAccount();

  return useMemo(() => Boolean(address && tokenService.tokens), [address, tokenService.tokens]);
};
